import { useQuery } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import HttpUtils from '~/agent/http-utils';

export interface SearchUser {
  id: string;
  userId: string;
  label: string;
  value: string; // This is equivalent to email
  name: string | null;
  avatar: string | null;
  isUser: boolean;
  userType: 'internal' | 'external';
}

interface GetInternalUsersQueryParams {
  searchTerm?: string;
  excludedUserIds?: (string | number)[];
  enabled?: boolean;
}

export function useGetInternalUsersQuery({ searchTerm, excludedUserIds, enabled = true }: GetInternalUsersQueryParams) {
  return useQuery<SearchUser[], JQuery.jqXHR>(
    ['users_search', searchTerm, excludedUserIds],
    () =>
      FetchPromise.get(
        HttpUtils.buildUriWithQueryString(
          'users/search',
          {
            term: searchTerm,
            excluded_user_ids: excludedUserIds,
          },
          true,
        ),
      ),
    {
      enabled,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  );
}

interface GetInternalUsersByIdsQueryParams {
  userIds: string[];
  enabled?: boolean;
}

export function useGetInternalUsersByIdQuery({ userIds, enabled = true }: GetInternalUsersByIdsQueryParams) {
  return useQuery<SearchUser[], JQuery.jqXHR>(
    ['users_search_by_ids', userIds],
    () =>
      FetchPromise.get(
        HttpUtils.buildUriWithQueryString(
          'users/search',
          {
            limit_to_user_ids: userIds || [],
            allow_nil_search_term: Boolean(userIds.length),
          },
          true,
        ),
      ),
    {
      enabled,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  );
}
